import React from "react";

function Coin({ name, icon, price, symbol }) {
  // let pri = Math.round(price)
  return (
    <div className="coin">
      <h1>Name: { name} </h1>
      <img src= { icon} alt="abc" />
      {/* <h3>Price: {pri}</h3>   to get without decimel */}
      <h3>Price: {price} </h3>
      <h3>Symbol: { symbol} </h3>
    </div>
  );
}

export default Coin;
